import ReactInputMask from "react-input-mask";
import * as React from "react";
import { HRQuestionId } from "../../messages/ObjectIds";
import assertNever from "assert-never";
import { HRQuestionWithStatus } from "../../models/HR";
import { HRQuestion } from "../../messages/HR";
import { GenericInputHeader } from "./GenericInputHeader";
import { Globals } from "../../Globals";

interface GenericMaskedInputProps {
    hrMaskedQuestion: HRQuestionWithStatus<HRQuestion.PhoneNumberQuestion | HRQuestion.SSNQuestion>;
    isHidden: boolean;
    onChange: (newVal: string | null, id: HRQuestionId) => void;
    onBlur: (questionId: HRQuestionId) => void;
}

export class GenericMaskedInput extends React.Component<GenericMaskedInputProps> {
    constructor(props: GenericMaskedInputProps) {
        super(props);
        if (props.hrMaskedQuestion.question.answer !== null) {
            return;
        }

        switch (props.hrMaskedQuestion.question.type) {
            case "SSN": {
                const lastSSN = Globals.getLastSSN();
                if (lastSSN !== null) {
                    this.handleChange(lastSSN, props.hrMaskedQuestion.question.id);
                    props.onBlur(props.hrMaskedQuestion.question.id);
                }
                break;
            }
            case "PhoneNumber": {
                const lastPick = Globals.getAnswerByTemplateId(props.hrMaskedQuestion.question.textId);
                if (lastPick !== null) {
                    this.handleChange(lastPick, props.hrMaskedQuestion.question.id);
                    props.onBlur(props.hrMaskedQuestion.question.id);
                }
                break;
            }
            default: {
                return assertNever(props.hrMaskedQuestion.question);
            }
        }
    }

    handleChange(newVal: string, id: HRQuestionId) {
        const onlyDigits = this.getOnlyDigits(newVal);
        switch (this.props.hrMaskedQuestion.question.type) {
            case "SSN": {
                this.props.onChange(onlyDigits, id);
                return;
            }
            case "PhoneNumber": {
                if (onlyDigits.length === 0) {
                    this.props.onChange("", id);
                } else {
                    this.props.onChange("+1" + onlyDigits, id);
                }
                return;
            }
            default: {
                return assertNever(this.props.hrMaskedQuestion.question);
            }
        }
    }

    getOnlyDigits(newVal: string): string {
        return newVal.replace(/\D/g, "");
    }

    getMask() {
        switch (this.props.hrMaskedQuestion.question.type) {
            case "PhoneNumber": {
                return "(999)-999-9999";
            }
            case "SSN": {
                return "999-99-9999";
            }
            default:
                return assertNever(this.props.hrMaskedQuestion.question);
        }
    }

    getPlaceholder(): string {
        switch (this.props.hrMaskedQuestion.question.type) {
            case "PhoneNumber": {
                return "Phone number";
            }
            case "SSN": {
                return "SSN";
            }
            default:
                return assertNever(this.props.hrMaskedQuestion.question);
        }
    }

    getValue(): string | undefined {
        const question = this.props.hrMaskedQuestion.question;
        switch (question.type) {
            case "PhoneNumber": {
                if (question.answer !== null) {
                    return question.answer.substring(2, question.answer.length);
                }
                return undefined;
            }
            case "SSN": {
                return question.answer === null ? undefined : question.answer;
            }
            default:
                return assertNever(question);
        }
    }

    render() {
        const question = this.props.hrMaskedQuestion.question;
        const status = this.props.hrMaskedQuestion.status;
        return (
            <div className="control-group" style={this.props.isHidden ? { display: "none" } : { display: "" }}>
                <GenericInputHeader status={status} questionText={question.questionText}/>
                <ReactInputMask
                    className={"form-control"}
                    onChange={(e) => this.handleChange(e.target.value, question.id)}
                    value={this.getValue()}
                    mask={this.getMask()}
                    maskChar={null}
                    onBlur={() => this.props.onBlur(question.id)}
                    placeholder={this.getPlaceholder()}
                    type={"tel"}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/inputs/GenericMaskedInput.tsx